import React, { useState, useEffect } from "react";
import CryptoJS from "crypto-js";
import { formatBirthdateForUI } from "utils/helpers";

const UserInfoBox = ({ user, refetch, openModal }) => {
  const [last4SSN, setLast4SSN] = useState("");
  const [ssnResult, setSSNResult] = useState(null);
  const [shouldShowSSNCheck, setShouldShowSSNCheck] = useState(false);

  const checkSSN = () => {
    const { ssn_last_four } = user;
    setShouldShowSSNCheck(true);
    if (CryptoJS.SHA256(last4SSN).toString() === ssn_last_four) {
      setSSNResult(true);
      return;
    }
    setSSNResult(false);
  };

  useEffect(() => {
    if (last4SSN.length === 4) {
      checkSSN();
    } else { setShouldShowSSNCheck(false); }
  }, [last4SSN]);

  return (
    <div className="flex flex-col p-auto font-bold justify-start bg-gray-300 pt-4 pr-4 pl-4 h-48 gap-3 rounded-md shadow ml-8 w-4/12 mr-10">
      <div className="flex justify-between">
        <span>Phone Number:</span>
        <div>
          <span className="mr-2">{user.phone_number}</span>
          <button
            type="button"
            style={{ outline: 0 }}
            className="btn-green w-16 text-white font-bold rounded-lg outline-0"
            onClick={(e) =>
              openModal(e, "UpdatePhoneModal", {
                user,
                refetch,
                setPhoneUpdated: () => {},
                setNewNum: () => {},
              })
            }
          >
            Edit
          </button>
        </div>
      </div>
      <div className="flex justify-between">
        <span>Date of Birth:</span>
        <div>
          <span className="cursor-pointer mr-2">
            {user.dob ? formatBirthdateForUI(user.dob) : "N/A"}
          </span>
          <button
            type="button"
            style={{ outline: 0 }}
            className="btn-green w-16 text-white font-bold rounded-lg outline-0"
            onClick={(e) =>
              openModal(e, "UpdateDOBModal", {
                user,
                refetch,
                setNewDOB: () => {},
                setDOBUpdated: () => {},
              })
            }
          >
            Edit
          </button>
        </div>
      </div>
      {user.ssn_last_four ? (
        <div className="flex items-center justify-between">
          <input
            className="flex border border-gray-400 rounded-btn px-4 py-2 mt-4"
            maxLength={4}
            onChange={(e) => setLast4SSN(e.target.value)}
            placeholder="Enter users last 4 SSN"
            type="text"
            value={last4SSN}
          />
          {shouldShowSSNCheck && (
            <i
              className={`mt-4 ml-4 text-5xl ${
                ssnResult
                  ? "fa fa-check-square text-green-400"
                  : "fa fa-times text-red-400"
              } `}
            />
          )}
        </div>
      ) : (
        <div>SSN Not on file</div>
      )}
    </div>
  );
};

export default UserInfoBox;